<template>
    <v-container fluid>
        <v-row>
            <v-col sm="12">
                <v-card>
                    <benutzer-liste :benutzer-list="praxisgruppeBenutzerData" />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';

import { NAME as NAME_PRAXISGRUPPEADMINISTRATION } from '../store';
import { NAME as NAME_GENERAL } from '@/store/modules/general';
import { NAME as NAME_SECURITY } from '@/store/modules/security';
import { NAME as NAME_HEADERNOTIFICATION } from '@/store/modules/headerNotification';

const praxisgruppeAdministrationModul = namespace(NAME_PRAXISGRUPPEADMINISTRATION);
const generalModul = namespace(NAME_GENERAL);
const securityModul = namespace(NAME_SECURITY);
const headerModul = namespace(NAME_HEADERNOTIFICATION);

import { HASACCESS } from '@/store/modules/security/getters';
import { SETACCESSDENIED } from '@/store/modules/security/mutations';
import { NEW_ALERT } from '@/store/modules/headerNotification/actions';
import { GETPRAXISGRUPPEBENUTZERDATA } from '../store/getters';
import { SUBTITLE, FOOTERTITLE } from '@/store/modules/general/mutations';
import BenutzerListe from './PraxisgruppeBenutzerListe.vue';
import { TeilnehmerBenutzerDto } from '@/types/UserDtos';
import { GET_BENUTZER_BY_ID } from '@/areas/praxisgruppeadministration/store/actions';
@Component({
    components: {
        BenutzerListe
    }
})
export default class Profil extends Vue {
    @generalModul.Mutation(FOOTERTITLE) setFooterTitle!: Function;
    @generalModul.Mutation(SUBTITLE) setSubTitle!: Function;
    @securityModul.Getter(HASACCESS) hasAccess!: Function;
    @securityModul.Mutation(SETACCESSDENIED) setAccessDenied!: Function;
    @headerModul.Action(NEW_ALERT) alertMessage!: Function;
    @praxisgruppeAdministrationModul.Getter(GETPRAXISGRUPPEBENUTZERDATA) praxisgruppeBenutzerData!: Array<TeilnehmerBenutzerDto>;
    @praxisgruppeAdministrationModul.Action(GET_BENUTZER_BY_ID) getBenutzer!: Function;

    mounted() {
        this.setSubTitle(this.$t('praxisgruppe.einstellungen.subtitle'));
        this.setFooterTitle('S720');
        if (!this.hasAccess('Navigation.PraxisgruppeEinstellungen')) {
            this.setAccessDenied(true);
            this.alertMessage({ text: this.$t('errormessage.noaccesspage') });
        } else {
            this.setAccessDenied(false);
            this.getBenutzer();
        }
    }
}
</script>
